/**
 * React Query hook for fetching available proposal tags
 */
import { useQuery } from '@tanstack/react-query';
import { getAvailableProposalTags } from '../services/ProposalTagsService';
/**
 * Hook for fetching available proposal tags
 * @param proposalId - The proposal ID
 * @returns Query result with available tags data
 */
export default function useAvailableTags(proposalId) {
    return useQuery(['proposal-available-tags', proposalId], () => getAvailableProposalTags(proposalId), {
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // exponential backoff with max of 30 seconds
        refetchOnWindowFocus: false,
        enabled: !!proposalId
    });
}
